/* eslint-disable react-hooks/exhaustive-deps */
import { useRouter } from 'next/router';
import React, { useEffect } from 'react';

function FinanciarCarroParticular13SalarioRedirect({ posts, categories }) {
  useEffect(() => {
    window.location.href = `../`;
  }, []);
  return <>{/*  */}</>;
}
//   const router = useRouter();
//   useEffect(() => {
//     router.replace(`/${window.location.search}`);
//   }, []);
//   return <>{/*  */}</>;
// }

// export const config = {
//   amp: false,
// };

// export async function getStaticProps() {
//   return {
//     props: {},
//   };
// }

export default FinanciarCarroParticular13SalarioRedirect;
